<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="contact-mf">
                    <div id="contact" class="box-shadow-full">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="title-box-2">
                                    <h3 class="title-left fadeInUp animated">
                                        Contact Me Now
                                    </h3>
                                </div>
                                <div>
                                    <form @submit.prevent="onSubmit">
                                    
                                        <div class="input fadeInUp animated" :class="{invalid: $v.name.$error}">
                                            <input type="text" id="name" placeholder="Your Name..." @blur="$v.name.$touch()" v-model="newUser.name">
                                        </div>
                                    
                                        <div class="input fadeInUp animated" :class="{invalid: $v.email.$error}">
                                            <input type="email" id="email" placeholder="Your email..." @blur="$v.email.$touch()" v-model="newUser.email">
                                            <!-- <p v-if="!$v.email.email">Please provide a valid email address.</p>        -->
                                        </div>
                                    
                                        <div class="input fadeInUp animated" :class="{invalid: $v.msg.$error}">
                                            <textarea id="msg" placeholder="Your message..." rows="3" @blur="$v.msg.$touch()" v-model="newUser.msg"></textarea>
                                        </div>
                                    
                                        <div class="submit fadeInUp animated">
                                            <button type="submit" :disabled="!isValid">Let's get in touch</button>
                                        </div>
                                    
                                    </form>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="title-box-2 pt-4 pt-md-0">
                                    <h3 class="title-left fadeInUp animated">
                                        Contact Details
                                    </h3>
                                </div>
                                <div class="more-info">
                                    <p class="lead fadeInUp animated">
                                        If you have any query about my projects, feel free to contact me on below information! I'll get back to you ASAP!
                                    </p>
                                    <ul class="list-ico fadeInUp animated">
                                        <li>
                                            <i class="fas fa-map-marker-alt"></i> 新北市永和區成功路一段125巷3號</li>
                                        <li>
                                            <i class="fas fa-phone"></i> (+886) 0912801025</li>
                                        <li>
                                            <i class="fas fa-envelope"></i>
                                            <a href="mailto:hello@rkrs.rocks">hello@rkrs.rocks</a></li>
                                        <li>
                                            <a href="https://github.com/rkrshen" target="_blank"><i class="fab fa-github"></i></a>&nbsp; &nbsp; &nbsp; 
                                            <a href="https://www.facebook.com/rkrshen" target="_blank"><i class="fab fa-facebook"></i></a>&nbsp; &nbsp; &nbsp; 
                                            <a href="https://www.instagram.com/rkrshen/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



<script>

  import { required, email } from 'vuelidate/lib/validators'
  import Vue from 'vue'
  import firebase from 'firebase/app'
  import 'firebase/database'
  import vuefire from 'vuefire'
  Vue.use(vuefire)

let config = {
  apiKey: 'AIzaSyBmhUdgNx8wJHJRcbPW36wSSlupd6xYl88',
  authDomain: 'rkrsrocks.firebaseapp.com',
  databaseURL: 'https://rkrsrocks.firebaseio.com',
  projectId: 'rkrsrocks',
  storageBucket: 'rkrsrocks.appspot.com',
  messagingSenderId: '1011734916176'
}
firebase.initializeApp(config)
let usersRef = firebase.database().ref('users')

  export default {
    
    data () {
        return {
            newUser: {
              name: '',
              email: '',
              msg: ''
            }
          }
    },

    validations: {
              name: {  },
              email: {  },
              msg: {  }
        
    },

    firebase: {
      users: usersRef
    },
    
    methods: {
  
      onSubmit () {
        usersRef.push(this.newUser)
        this.newUser.name = ''
        this.newUser.email = ''
        this.newUser.msg = ''
        // name: this.name,  
        // email: this.email,
        // msg: this.msg

        // console.log(formData)

        // axios.post('https://rkrsrocks.firebaseio.com/emails.json', formData)
        // .then(res => console.log(res))
        // .catch(error => console.log(error))
        alert("Thank you for your message ;) It has been sent.");

        }
    },
    computed: {
      isValid: function () {
        return this.newUser.name !== '' && this.newUser.email !== '' && this.newUser.msg !== ''
      }
    }
            
  }
</script>

<style scoped>

@import url("https://use.fontawesome.com/releases/v5.0.13/css/all.css");

/* #contact {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family:comfortaa;
  color: black;
  
  }
  .contact-container {
    width: 300px;
    padding: 5px;
    
  }

.contact-header {
  position: relative;
  text-align: center;
  left: 50%;
  transform: translate(-50%);
  font-family:comfortaa;
  font-size: 18px;
  } */
  .contact-mf {
    margin-top: 13vh;
  }


  .input {
    margin: 40px auto;
  }


  .input input{
    
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    background-color: transparent;
    border-color: transparent;
    border-bottom-color: #2f2f2f;
  
  }
  .input textarea{
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    background-color: transparent;
    border: solid 2px  #2f2f2f;
  }

  .input p{
    font-size: 10px;
    color: #ff4d5a;
    margin-top: 8px;
  
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    
    outline: none;
    border-bottom-color: black;
    color: black;
  }
  .input textarea:focus {
    outline: none;
    border-color: black;
    color: black;
  }

  .input.invalid input{
    border-bottom-color: #ff4d5a;
    color: #ff4d5a;
  }
  .input.invalid textarea{
    border-color: #ff4d5a;
    color: #ff4d5a;
  }

  .submit button {
    background-color: transparent;
    border: 1px solid black;
    border-radius: 100px;
    color: black;
    padding: 5px 10px;
    font: inherit;
    cursor: pointer;
    margin-left: 50%;
    transform: translate(-50%); 
    font-size: 12px;
    
  }

  .submit button:hover,
  .submit button:active
  {
    background-color: white;
    color: black;
    outline: none;
  }
  .submit button:focus {
    outline: none;
  }

  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ff4d5a;
    background-color: transparent;
    color: #ff4d5a;
    cursor: not-allowed;
    outline: none;
  }

  .list-ico {
    line-height: 3;
    padding-left: 0;
  }

  li {
    list-style: none;
    margin: 0;
  }

  a {
    color: black
  }

  h3 {
    font-weight: 500;
  }

  p {
    line-height: 2rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue